import React from 'react';
import './style.css';
import { Link } from 'react-router-dom';
import tm1 from '../../images/team/1.png';

const WorldSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={`wpo-world-area ${props.worldclass}`}>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='wpo-world-section'>
              <h3>Be compassionate and help your community!</h3>
              <h3 className='details'>
                Help change lives in Rwanda and East Africa, gain more
                knowledge, gain valuable experience, practical work, make new
                friends while volunteering at LHCF and obtain an outstanding
                recommendation letter.
              </h3>
              <Link onClick={ClickHandler} to='/Volunteer' className='mt-4'>
                <img src={tm1} alt='' /> Become A Volunteer
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorldSection;
